import React, { useEffect, useRef } from 'react';
import { DropdownContainer, DropdownButton, DropdownMenu } from './dropdown.styles';

export const Dropdown = ({
    options = [],
    defaultLabel = 'Select',
    value,
    onChange,
    isOpen = false,
    onOpen,
    onClose
}) => {
    // 確保 selected 每次 value 改變時都能正確顯示
    // 用字串比對，避免 value 來自 URL 參數（字串）而選項是數字時對不到
    const selectedOption = options.find(option => String(option.value) === String(value));
    const selectedLabel = selectedOption ? selectedOption.label : defaultLabel;
    const currentRef = useRef(null);

    // 點擊按鈕時打開 dropdown，並通知父層
    const toggleDropdown = () => {
        if (isOpen) {
            onClose?.();
        } else {
            onOpen?.();
        }
    };

    // 點選選項時，關閉 dropdown 並通知父層 + 回傳選項
    const handleOptionClick = (option) => {
        onClose?.();
        if (onChange) {
            onChange(option.value);
        }
    };

    // 點擊外部自動關閉（選用：可以加 document listener）
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.custom-dropdown')) {
                if (isOpen) {
                    onClose?.();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen && currentRef.current) {
            currentRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [isOpen]);

    return (
        <DropdownContainer className="custom-dropdown">
            <DropdownButton onClick={toggleDropdown} isOpen={isOpen}>
                {selectedLabel}
            </DropdownButton>
            {isOpen && (
                <DropdownMenu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {options.map((option, index) => {
                        const isSelected = option.value === value; // ✅ 判斷目前選中的項目

                        return (
                            <div
                                key={index}
                                ref={option.isCurrent ? currentRef : null}
                                onClick={() => !option.disabled && handleOptionClick(option)}  // 👈 disabled 不觸發
                                style={{
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    color: option.disabled ? '#bbb' : isSelected ? '#000' : undefined,
                                    backgroundColor: option.disabled
                                        ? '#f5f5f5'
                                        : isSelected ? 'rgba(97, 203, 201, 0.5)' : undefined,
                                    borderRadius: isSelected ? '6px' : undefined,
                                    padding: '8px 10px',
                                    margin: '2px 0',
                                    cursor: option.disabled ? 'not-allowed' : 'pointer',  // 👈 游標變禁止
                                }}
                            >
                                {option.label}
                            </div>
                        );
                    })}

                </DropdownMenu>
            )}

        </DropdownContainer>
    );
};
